module.exports = __webpack_public_path__ + "static/media/150.0052630b.svg";